module.exports = __webpack_public_path__ + "static/media/franchise-blue-icon.eccefd77.svg";